import React from 'react';

import AssistantMessage from './assistant_message';
import LoadingSpinner from 'components/ui/loading_spinner';
import UserMessage from './user_message';

import type { Message } from '../types';

interface Props {
  // What stands in for a conversation that has not started. Surface-specific -- the assistant offers
  // its starters and a resume link, the doc editor offers example page edits -- so it is passed in
  // rather than picked here.
  empty: React.ReactNode;
  messages: Message[];
  restoring: boolean;
}

export function Transcript({ empty, messages, restoring }: Props) {
  // A card is only history once the user has typed past it. An assistant message after it is the
  // reply it is still waiting on - or the error from a failed attempt, which it can be retried from.
  const lastUserIndex = messages.reduce((last, { role }, index) => (role === 'user' ? index : last), -1);

  if (messages.length === 0) {
    return <>{restoring ? <LoadingSpinner /> : empty}</>;
  }

  return (
    <>
      {messages.map((message, index) => (
        message.role === 'user'
          ? <UserMessage key={index} message={message} />
          : <AssistantMessage key={index} message={message} superseded={index < lastUserIndex} />
      ))}
    </>
  );
}
